export const LayoutType = {
  Default: "Default",
  HideScrollTop: "HideScrollTop",
} as const;

export type LayoutType = (typeof LayoutType)[keyof typeof LayoutType];
